export default __webpack_public_path__ + "static/media/milly.708085fd.jpg";